import {
  BetHistoryPortrait,
  ErrorPopup,
  Ga4EventType,
  ga4Info,
  GodziSlotLoadingFeatureToggleV2,
  PixiApp,
  RealityCheckPopupFeatureToggleV2,
  SessionLimitPopup,
} from '@slot-nx/core'
import { useMachine } from '@xstate/react'
import { useEffect, useState } from 'react'
import { GameUI } from './GameUI'
import { gameConfig } from '../config'
import { Tutorial } from './Tutorial'
import { Game } from './Game'
import { BetDetail } from './betDetailV2/BetDetail'
import { screenMachine } from '../domain/screen/screenMachine'
import { threecomboolympusMachine } from '../domain/machine/threecomboolympusMachine'
import { registerNormalSpaceBarEvent } from '../domain/spin/SpinUtil'
import { betDetailService } from '../domain/betDetail/service/BetDetailService'
import { useBetDetailStore } from '../domain/betDetail/store/betDetailStore'
import { ChangePose } from './ChangePose/ChangePose'
export const App = () => {
  const [screenSnapshot, send] = useMachine(screenMachine)
  // 達到 session 限額時的強制彈窗不能打斷進行中的一手
  const [isRoundSettled, setIsRoundSettled] = useState(
    threecomboolympusMachine.getSnapshot().matches('init game'),
  )

  useEffect(() => {
    const subscription = threecomboolympusMachine.subscribe((snapshot) => {
      setIsRoundSettled(snapshot.matches('init game'))
    })
    return () => {
      subscription.unsubscribe()
    }
  }, [])

  const exitTutorial = () => {
    ga4Info.addEvent(Ga4EventType.enter_main_game)
    ga4Info.recordStayTime()
    registerNormalSpaceBarEvent()
    send({ type: 'exit tutorial' })
    threecomboolympusMachine.send({ type: 'tutorial end' })
  }

  if (screenSnapshot.matches('GodziSlot Loading')) {
    return <GodziSlotLoadingFeatureToggleV2 />
  }

  return (
    <>
      <PixiApp
        element={document.getElementById('root') as HTMLElement}
        resolution={gameConfig.resolution}
      >
        <Tutorial onpointerdown={exitTutorial} isVisible={screenSnapshot.matches('Tutorial')} />
        <Game isVisible={!screenSnapshot.matches('Tutorial')} />
        {/*
          以下都是要蓋在整個 Game（含 HUD）之上的全螢幕內容，
          順序即 z-order：後面的蓋前面的。
        */}
        <BetHistoryPortrait
          width={gameConfig.resolution.width}
          height={gameConfig.resolution.height}
          openBetDetail={(refNo: number, statementDate: string) => {
            useBetDetailStore.setState({ isOpen: true })
            betDetailService.getBetDetail(refNo, statementDate)
          }}
        />
        <BetDetail />
        <ErrorPopup gameHeight={gameConfig.resolution.height} gameWidth={gameConfig.resolution.width} />
        <RealityCheckPopupFeatureToggleV2 gameHeight={gameConfig.resolution.height} gameWidth={gameConfig.resolution.width} />
        <SessionLimitPopup gameHeight={gameConfig.resolution.height} gameWidth={gameConfig.resolution.width} isRoundSettled={isRoundSettled} />
        <ChangePose />
      </PixiApp>
      <GameUI />
    </>
  )
}
